import React from 'react';
import { Tag } from 'antd';
import { UserOutlined } from '@ant-design/icons';

interface MentionTextProps {
  text: string;
}

const MentionText: React.FC<MentionTextProps> = ({ text }) => {
  // Регулярное выражение для поиска упоминаний в тексте
  const mentionRegex = /@([a-zA-Z0-9._=-]+):?([a-zA-Z0-9.-]*)?/g;
  
  const renderTextWithMentions = (text: string) => {
    const parts = [];
    let lastIndex = 0;
    let match;

    while ((match = mentionRegex.exec(text)) !== null) {
      const [fullMatch, username, domain] = match;
      const startIndex = match.index;

      // Добавляем текст перед упоминанием
      if (startIndex > lastIndex) {
        parts.push(text.slice(lastIndex, startIndex));
      }

      // Создаем компонент упоминания
      const displayName = domain ? `${username}:${domain}` : username;
      parts.push(
        <Tag
          key={`mention-${startIndex}`}
          icon={<UserOutlined />}
          color="blue"
          style={{
            margin: '0 2px',
            fontSize: '12px',
            height: 'auto',
            padding: '1px 6px',
            borderRadius: '4px',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '2px'
          }}
        >
          @{displayName}
        </Tag>
      );

      lastIndex = startIndex + fullMatch.length;
    }

    // Добавляем оставшийся текст
    if (lastIndex < text.length) {
      parts.push(text.slice(lastIndex));
    }

    return parts.length > 0 ? parts : [text];
  };

  return (
    <span style={{ wordWrap: 'break-word', whiteSpace: 'pre-wrap' }}>
      {renderTextWithMentions(text)}
    </span>
  );
};

export default MentionText; 